import React from 'react';
import { Search } from 'lucide-react';

interface ConversationsFiltersProps {
  search: string;
  model: string;
  onSearchChange: (value: string) => void;
  onModelChange: (value: string) => void;
  modelOptions: string[];
}

const ConversationsFilters: React.FC<ConversationsFiltersProps> = ({
  search,
  model,
  onSearchChange,
  onModelChange,
  modelOptions,
}) => (
  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
      <div className="relative">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
        <input
          type="search"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search by artist"
          className="w-full pl-10 pr-3 py-2.5 text-sm border border-gray-200 rounded-lg font-family-messina-sans text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
        />
      </div>
      <select
        value={model}
        onChange={(e) => onModelChange(e.target.value)}
        className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-lg font-family-messina-sans text-gray-900 bg-white focus:outline-none focus:ring-2 focus:ring-gray-200"
      >
        <option value="">All models</option>
        {modelOptions.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  </div>
);

export default ConversationsFilters;
